// extracted by mini-css-extract-plugin
export default {"slider":"iHSzm","slider__nav":"GEE12","slider__nav_left":"doE8K","slider__nav_right":"HPmYm","appear-from-above":"EtYqW","appearFromAbove":"EtYqW"};